module.exports = __webpack_public_path__ + "static/media/jnt.9b454cbe.png";